$(document).ready(function() {
    var loadingIndicator = $('#loading-indicator');
    var submitButton = $('.submit-form-btn');
    var cancelButton = $('.delta-disable-onsubmit');
    var elementsToHide = $('.delta-hide-onsubmit');

    if (submitButton.length > 0) {
        submitButton.on('click', function(event) {
            loadingIndicator.css('display', 'block');
            if (elementsToHide.length > 0) {
                elementsToHide.hide();
            }
            cancelButton.attr("disabled", true);
            setTimeout( () => {
                    event.target.disabled=true;
                }, 0
            )
        });
    }
});